import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import Hero from "@/components/matcher/Hero";
import StepForm from "@/components/matcher/StepForm";
import Distilling from "@/components/matcher/Distilling";
import Results from "@/components/matcher/Results";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const STAGES = {
  HERO: "hero",
  FORM: "form",
  LOADING: "loading",
  RESULTS: "results",
};

export default function Matcher() {
  const [stage, setStage] = useState(STAGES.HERO);
  const [options, setOptions] = useState(null);
  const [result, setResult] = useState(null);
  const [answers, setAnswers] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/options`)
      .then((r) => setOptions(r.data))
      .catch(() => toast.error("Could not load options."));
  }, []);

  const handleStart = () => setStage(STAGES.FORM);

  const handleSubmit = async (payload) => {
    setAnswers(payload);
    setStage(STAGES.LOADING);
    try {
      const r = await axios.post(`${API}/match`, payload, {
        timeout: 90_000,
      });
      setResult(r.data);
      setStage(STAGES.RESULTS);
    } catch (e) {
      toast.error("The atelier is quiet. Please try again.");
      setStage(STAGES.FORM);
    }
  };

  const handleRestart = () => {
    setResult(null);
    setAnswers(null);
    setStage(STAGES.HERO);
  };

  return (
    <main
      className="min-h-screen w-full bg-background text-foreground overflow-x-hidden"
      data-testid="matcher-page"
    >
      {stage === STAGES.HERO && <Hero onStart={handleStart} />}
      {stage === STAGES.FORM && options && (
        <StepForm options={options} onSubmit={handleSubmit} />
      )}
      {stage === STAGES.LOADING && <Distilling />}
      {stage === STAGES.RESULTS && result && (
        <Results result={result} answers={answers} onRestart={handleRestart} />
      )}
    </main>
  );
}
